export default "__VITE_ASSET__BYSeJKks__"